import { render, staticRenderFns } from "./dictionaryManage.vue?vue&type=template&id=b47daf66&"
import script from "./dictionaryManage.vue?vue&type=script&lang=ts&"
export * from "./dictionaryManage.vue?vue&type=script&lang=ts&"
import style0 from "./dictionaryManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports